import { styled } from '@mui/material';

export const ProjectPageRoot = styled('div')({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
});
